"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    StyledLoadingBox: ()=>StyledLoadingBox
});
const external_styled_components_namespaceObject = require("styled-components");
var external_styled_components_default = /*#__PURE__*/ __webpack_require__.n(external_styled_components_namespaceObject);
const external_pcln_design_system_namespaceObject = require("pcln-design-system");
const StyledLoadingBox = /*#__PURE__*/ external_styled_components_default()(external_pcln_design_system_namespaceObject.Flex).withConfig({
    displayName: "StyledLoadingBubble__StyledLoadingBox"
})([
    "border-radius:16px;padding-left:11px;padding-right:11px;@keyframes blink_1{0%{opacity:0.3;}10%{opacity:0.6;}33%{opacity:1;}66%{opacity:0.6;}99%{opacity:0.3;}}@keyframes blink_2{0%{opacity:0.3;}33%{opacity:0.6;}66%{opacity:1;}99%{opacity:0.6;}}@keyframes blink_3{0%{opacity:0.1;}33%{opacity:0.3;}66%{opacity:0.6;}99%{opacity:1;}}div#ellipses_1{animation:blink_1 1s infinite;}div#ellipses_2{animation:blink_2 1s infinite;}div#ellipses_3{animation:blink_3 1s infinite;}"
]);
exports.StyledLoadingBox = __webpack_exports__.StyledLoadingBox;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "StyledLoadingBox"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
